import { observer } from 'mobx-react-lite';
import { AppRoutes } from '~/app/app.routes';
import { FeedbackService } from '~/service/service.feedback';
import { useService } from '~/shared/service/service.base';
import { Col } from '../view.box';
import { LinkView } from '../view.link';
import { FeedbackDrawerItem, FeedbackDrawerTitle, FeedbackDrawerValue } from './feedback.drawer';

export const FeedbackDrawerUser = observer(() => {
	const [{ selectedItem }] = useService(FeedbackService);
	if (!selectedItem) return null;

	return (
		<Col gap={1}>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Complaint:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem?.complaint}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>User:</FeedbackDrawerTitle>
				<LinkView to={AppRoutes.UserEdit.buildPath({ id: selectedItem?.userId ?? 0 })} target="_blank">
					{selectedItem.userName}
				</LinkView>
			</FeedbackDrawerItem>
		</Col>
	);
});
